<template>
    <div>
        <modal-add-redirect ref="addRedirectDialog"/>
        <modal-edit-redirect ref="editRedirectDialog"/>
        <v-row>
            <v-col cols="12">
                <v-btn @click="showAddRedirectModal()">Dodaj przekierowanie</v-btn>
                <data-table
                        ref="table"
                        :headers="headers"
                        :items="redirects"
                        :options.sync="options"
                        :loading="loading"
                        class="elevation-1 row-pointer"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-icon
                        small
                        :disabled="!!item.processed"
                        @click="showEditRedirectModal(item, $event)"
                        title="Edytuj"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                        small
                        :disabled="!!item.processed"
                        @click="onRemoveBtnTriggered(item, $event)"
                        title="Usuń"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import api from '../services/api';
    import DataTable from "@/components/data-table/DataTable";
    import formatters from '@/mixins/formatters';
    import permissions from '@/mixins/permissions';
    import ModalAddRedirect from "../components/ModalAddRedirect";
    import ModalEditRedirect from "../components/ModalEditRedirect";

    export default {
        mixins: [
            formatters,
            permissions,
        ],
        components: {
          DataTable,
          ModalAddRedirect,
          ModalEditRedirect,
        },
        data () {
            return {
                redirects: [],
                loading: true,
                options: {},
                headers: [
                    { text: 'Adres źródłowy', value: 'from', sortable: false },
                    { text: 'Adres docelowy', value: 'to', sortable: false },
                    { text: 'Akcje', value: 'actions', sortable: false },
                ],
                dialogRemove: false,
            }
        },
        methods: {
            async getRedirects() {
                this.loading = true;

                const response = await api.get('/api/redirects', {});
                this.loading = false;

                this.redirects = response.data;
            },
            remove(item, event = null) {
                if (this.loading) {
                  return;
                }

                let $icon = null;

                if (event) {
                  $icon = event.target;

                  // The following line is required to avoid triggering onRowClicked() method.
                  event.cancelBubble = true;
                }

                if (item.processed) {
                  return;
                }

                const id = item.id;
                item.processed = true;

                if ($icon) {
                  $icon.disabled = true;
                  $icon.classList.add('v-icon--disabled');
                }

                api.delete(`/api/redirects/${id}`)
                    .then(() => {
                      this.getRedirects();

                      this.$root.$emit('notifySuccess', {
                        html: `Przekierowanie zostało usunięte.`,
                      });
                    })
                    .catch((error) => {
                      if ($icon) {
                        $icon.disabled = false;
                        $icon.classList.remove('v-icon--disabled');
                      }

                      this.$root.$emit('notifyError', {
                        html: 'Nie udało się usunąć przekierowania.',
                        error,
                      });
                    })
                    .finally(() => {
                      delete item.processed;
                });
            },
            onRemoveBtnTriggered(item, event) {
              this.stopRowClickPropagation(event);
              this.remove(item, event);
            },
            stopRowClickPropagation(event) {
              // The following line is required to avoid triggering onRowClicked() method.
              event.cancelBubble = true;
              event.stopPropagation();
            },
            async showAddRedirectModal() {
              this.$refs.addRedirectDialog
                  .open()
            },
            async showEditRedirectModal(item) {
              this.$refs.editRedirectDialog
                  .open(item)
            },
        },
        created() {
          this.getRedirects();
        }
    }
</script>
